import PropTypes from 'prop-types';
import React from 'react';

import Channel from './Channel';

const Channels = ({ channels, episode, onEditRestream }) =>
	channels.map(channel =>
		<Channel
			channel={channel}
			episode={episode}
			key={channel.id}
			onEditRestream={onEditRestream}
		/>
	);

Channels.propTypes = {
	channels: PropTypes.arrayOf(PropTypes.shape({
	})),
	episode: PropTypes.shape({
	}),
	onEditRestream: PropTypes.func,
};

export default Channels;
